import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const resetPassword = ({ token, password, confirmPassword }) => {
  console.log(token, password, confirmPassword);
  return axios.post(`/api/v1/auth/resetpassword`, {
    token,
    password,
    confirmPassword,
  });
};

export const useResetPassword = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation(resetPassword, {
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Failed to reset password',
      });
    },
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Password Reset Successfully',
      });
    },
    ...config,
  });
};
